import * as fromDatatype from "../datatype-library/index";

export interface bl_crm_risk_spending_limit_alarm_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  entity_guid: fromDatatype.GuidDataFieldInterface;
  member_guid: fromDatatype.GuidDataFieldInterface;
  login_guid: fromDatatype.GuidDataFieldInterface;
  obj_type: fromDatatype.VarcharDatatypeInterface;
  date_txn_alert: fromDatatype.TimestampTzDatatypeInterface;
  date_txn_latest: fromDatatype.TimestampTzDatatypeInterface;
  date_txn_reset: fromDatatype.TimestampTzDatatypeInterface;
  amount_txn_total: fromDatatype.NumericDatatypeInterface;
  alert_level: fromDatatype.IntegerDatatypeInterface;
  alert_amount: fromDatatype.NumericDatatypeInterface;
  spend_count: fromDatatype.IntegerDatatypeInterface;
  txn_type: fromDatatype.VarcharDatatypeInterface;
  email_sent: fromDatatype.VarcharDatatypeInterface;
  phone_call: fromDatatype.VarcharDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}

export class bl_crm_risk_spending_limit_alarm_hdr_RowClass
  implements bl_crm_risk_spending_limit_alarm_hdr_RowInterface
{
  guid: fromDatatype.GuidDataFieldInterface;
  entity_guid: fromDatatype.GuidDataFieldInterface;
  member_guid: fromDatatype.GuidDataFieldInterface;
  login_guid: fromDatatype.GuidDataFieldInterface;
  obj_type: fromDatatype.VarcharDatatypeInterface;
  date_txn_alert: fromDatatype.TimestampTzDatatypeInterface;
  date_txn_latest: fromDatatype.TimestampTzDatatypeInterface;
  date_txn_reset: fromDatatype.TimestampTzDatatypeInterface;
  amount_txn_total: fromDatatype.NumericDatatypeInterface;
  alert_level: fromDatatype.IntegerDatatypeInterface;
  alert_amount: fromDatatype.NumericDatatypeInterface;
  spend_count: fromDatatype.IntegerDatatypeInterface;
  txn_type: fromDatatype.VarcharDatatypeInterface;
  email_sent: fromDatatype.VarcharDatatypeInterface;
  phone_call: fromDatatype.VarcharDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}
